const VARIANTS = {
  DEFAULT: 'default',
  SMALL: 'small',
};
const CARD_DESCRIPTION_MAX_HEIGHT_VARIANT_MAP = {
  [VARIANTS.DEFAULT]: '60px',
  [VARIANTS.SMALL]: '48px',
};
const CARD_NAME_MAX_HEIGHT_VARIANT_MAP = {
  [VARIANTS.DEFAULT]: '40px',
  [VARIANTS.SMALL]: '32px',
};
const CARD_LIST_MAX_SIZE_VARIANT_MAP = {
  [VARIANTS.DEFAULT]: 9,
  [VARIANTS.SMALL]: 4,
};

export { CARD_LIST_MAX_SIZE_VARIANT_MAP as C, VARIANTS as V, CARD_NAME_MAX_HEIGHT_VARIANT_MAP as a, CARD_DESCRIPTION_MAX_HEIGHT_VARIANT_MAP as b };
